export const GET_VENUE_LOYALTY= 'GET_VENUE_LOYALTY'
export const GET_VENUE_LOYALTY_SUCCESS= 'GET_VENUE_LOYALTY_SUCCESS'
export const GET_VENUE_LOYALTY_ERROR='GET_VENUE_LOYALTY_ERROR'

export const GetVenueLoyalty= (data) => ({
    type: GET_VENUE_LOYALTY,
    payload: data
})